import { useMemo } from "react";
import { Filter, FilterType, FilterValue } from "../types/filter";
import { isInputFilter } from "./filter/filter";

export function useChangedFiltersCount(
  filters: Filter[],
  filterValues: FilterValue[]
) {
  const changedFilterCount = useMemo(() => {
    const count = filters
      .flatMap((filter) => (isInputFilter(filter) ? filter : filter.filters))
      .reduce((accumulator, currentFilter) => {
        const filterValue = filterValues.find(
          (filterValue) => currentFilter.id === filterValue.filterId
        );
        if (
          currentFilter.enabled &&
          currentFilter.filterType !== FilterType.Sort &&
          filterValue &&
          filterValue.value !== currentFilter.defaultValue.value
        ) {
          return accumulator + 1;
        }
        return accumulator;
      }, 0);
    return count;
  }, [filterValues, filters]);

  return changedFilterCount;
}
